import type { FC } from 'react';

import { FileViewerControlsSection } from './components/FileViewerControlsSection'
import { FileViewerEmptyPreview } from './components/FileViewerEmptyPreview'
import { FileViewerFileList } from './components/FileViewerFileList'
import { FileViewerFileListItem } from './components/FileViewerFileListItem'
import { type IFileViewerFileListItemProps } from './components/FileViewerFileListItem/FileViewerFileListItem'
import { FileViewerPreview } from './components/FileViewerPreview'
import { FileViewerPreviewSection } from './components/FileViewerPreviewSection'
import { type IFileData } from '../File/File'

export const Components: FileViewerComponents<any> = {
  PreviewSection: FileViewerPreviewSection,
  Preview: FileViewerPreview,
  EmptyPreview: FileViewerEmptyPreview,
  ControlsSection: FileViewerControlsSection,
  FileList: FileViewerFileList,
  FileListItem: FileViewerFileListItem,
}

export interface FileViewerComponents<FileType = IFileData> {
  PreviewSection: FC
  Preview: FC
  EmptyPreview: FC
  ControlsSection: FC
  FileList: FC
  FileListItem: FC<IFileViewerFileListItemProps<FileType>>
}
